import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Day, Month } from '../../model/grid-calendar';

@Component( {
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'tr[grid-calendar-month]',
    templateUrl: './his-display-grid-calendar-month.component.html',
    styleUrls: ['./his-display-grid-calendar-month.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayGridCalendarMonthComponent implements OnInit {
    @Input() public month!: Month;
    @Output() public dateSelected: EventEmitter<{ day: Day, month: Month, isFrom: boolean }> = new EventEmitter<{ day: Day, month: Month, isFrom: boolean }>();

    ngOnInit(): void {
        return;
    }

    selectMonth( selected: { day: Day, isFrom: boolean } ): void {
        this.dateSelected.emit( { day: selected.day, month: this.month, isFrom: selected.isFrom } );
    }
}
